/**
 * OCHAT: the conversation-summary commands handed off to the external n8n
 * workflow, in one place.
 *
 * The agent picks "resumen" in the composer, Chatwoot posts a private note whose
 * body is one of the strings below, and an n8n workflow listening on the
 * message_created webhook recognises it, builds the summary and answers. Chatwoot
 * itself does not generate anything here.
 *
 * WHY THIS FILE EXISTS
 * The feature reached the composer by two independent paths, and each had invented
 * its own vocabulary, so they disagreed three ways:
 *
 *   ReplyTopPanel      sent '/ultimo resumen'  and '/resumen completo del historial'
 *   useCopilotReply    matched 'ultimo_resumen'/'resumen_general' and would have
 *                      sent '/ultimo_resumen' / '/resumen_general'
 *   CopilotMenuBar     emitted 'resumen_ultima'/'resumen_completo'
 *
 * Because CopilotMenuBar's keys were not the ones useCopilotReply matched, picking
 * a summary from the in-editor menu fell through to Chatwoot's own AI instead of
 * n8n, silently. Only the top-panel button actually reached the workflow.
 *
 * The strings below are the ones the top-panel button has been sending, i.e. the
 * ones n8n is known to accept today. They are deliberately the SPACED forms.
 *
 * VERIFY IN STAGING BEFORE RELEASE: confirm against the workflow in
 * growagente-byte/flujos-n8n that these are the exact strings it matches. Now that
 * the in-editor menu reaches n8n too, a mismatch shows up as a private note that
 * never gets an answer.
 */

/** Menu keys. Must match what useCopilotReply intercepts. */
export const SUMMARY_ACTIONS = {
  LAST: 'ochat_resumen_ultimo',
  FULL: 'ochat_resumen_completo',
};

/** The note body n8n matches on, per action. */
export const SUMMARY_COMMANDS = {
  [SUMMARY_ACTIONS.LAST]: '/ultimo resumen',
  [SUMMARY_ACTIONS.FULL]: '/resumen completo del historial',
};

/**
 * @param {string} action a SUMMARY_ACTIONS value
 * @returns {boolean} whether this action is an Ochat summary handoff
 */
export const isSummaryAction = action =>
  Object.hasOwn(SUMMARY_COMMANDS, action);

/**
 * @param {string} action a SUMMARY_ACTIONS value
 * @returns {string|undefined} the note body to post
 */
export const summaryCommandFor = action => SUMMARY_COMMANDS[action];
